import { render } from "./confirmAccountDeletionModal.vue?vue&type=template&id=232f889f&scoped=true&ts=true"
import script from "./confirmAccountDeletionModal.vue?vue&type=script&lang=ts"
export * from "./confirmAccountDeletionModal.vue?vue&type=script&lang=ts"

import "./confirmAccountDeletionModal.vue?vue&type=style&index=0&id=232f889f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232f889f"]])

export default __exports__